const Player = ({ player, toggle, selectedAudio, handleSelectAudio }) => {
  const handleSelect = (e, url) => {
    e.preventDefault();
    handleSelectAudio(url);
  };
  const handleToggle = (e) => {
    e.preventDefault();
    toggle();
  };

  console.log("Calling");
  return (
    <div className="col-sm-6">
      <div className="audio_bx mb-4">
        <h6 className="text-capitalize text-dark">{player.name}</h6>
        <div className="audio_rw">
          <div className="audio_range">
            <img
              src={
                player.playing
                  ? process.env.PUBLIC_URL +
                    "/assets/images/audio_range_selected.png"
                  : process.env.PUBLIC_URL + "/assets/images/audio_range.png"
              }
              className="img-fluid"
              alt="img"
            />
          </div>
          <div className="pause_play">
            <a href="#0" onClick={(e) => handleToggle(e)}>
              <img
                src={
                  player.playing
                    ? process.env.PUBLIC_URL + "/assets/images/pause.png"
                    : process.env.PUBLIC_URL + "/assets/images/play2.png"
                }
                alt="img"
                data-toggle="tooltip"
                data-placement="top"
                data-bs-original-title={player.playing ? "Pause" : "Play"}
              />
            </a>
          </div>
          <div className="add_audio">
            <a
              href="#0"
              data-toggle="tooltip"
              data-placement="top"
              title="Select Audio"
              onClick={(e) => handleSelect(e, player.url)}
            >
              <img
                src={
                  selectedAudio === player.url
                    ? process.env.PUBLIC_URL + "/assets/images/check.png"
                    : process.env.PUBLIC_URL + "/assets/images/add.png"
                }
                alt="img"
              />
            </a>
          </div>
        </div>
        {/* <button onClick={toggle}>{player.playing ? "Pause" : "Play"}</button> */}
      </div>
    </div>
  );
};

export default Player;
